import { render, staticRenderFns } from "./DashboardWise.vue?vue&type=template&id=6b065466&scoped=true&"
import script from "./DashboardWise.vue?vue&type=script&lang=js&"
export * from "./DashboardWise.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWise.vue?vue&type=style&index=0&id=6b065466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b065466",
  null
  
)

export default component.exports